module.exports = __webpack_public_path__ + "img/about-version.0abe8784.png";